import { BlueprintsTopbar } from './BlueprintsTopbar';
import BlueprintComponent from './[Blueprint]';
import './translations';
import { breadcrumbTranslation } from 'components/layout/Breadcrumb/utils';
import { BlueprintBreadcrumb } from 'components/layout/DynamicBreadcrumbs/BlueprintBreadcrumb';
import NewBlueprint from 'pages/Blueprints/NewBlueprint';
import 'pages/Blueprints/translations';
import { RequirePermission } from 'components/auth/RequirePermission';
import React from 'react';

const EditBlueprintLazy = React.lazy(() =>
  import('pages/Blueprints/EditBlueprint').then((m) => ({ default: (m as any).Component }))
);

export const blueprintsOverviewRoutes = [
  {
    path: 'solutions',
    breadcrumb: breadcrumbTranslation('blueprints'),
    element: (
      <RequirePermission permission="blueprint:read" redirectTo="/">
        <BlueprintsTopbar />
      </RequirePermission>
    ),
    children: [
      {
        index: true,
        lazy: () => import('pages/Blueprints/CardView'),
      },
    ],
  },
];

export const blueprintsRoutes = [
  {
    path: 'solutions',
    breadcrumb: breadcrumbTranslation('blueprints'),
    children: [
      {
        path: ':id',
        breadcrumb: BlueprintBreadcrumb,
        element: <BlueprintComponent />,
      },
    ],
  },
];

export const editBlueprintRoute = {
  path: 'solutions',
  breadcrumb: breadcrumbTranslation('blueprints'),
  children: [
    {
      path: ':id/edit',
      breadcrumb: breadcrumbTranslation('blueprints-edit'),
      element: (
        <RequirePermission permission="blueprint:update" redirectTo="/">
          <EditBlueprintLazy />
        </RequirePermission>
      ),
    },
  ],
};

export const newBlueprintRoute = {
  path: 'solutions',
  breadcrumb: breadcrumbTranslation('blueprints'),
  element: (
    <RequirePermission permission="blueprint:create" redirectTo="/">
      <NewBlueprint />
    </RequirePermission>
  ),
  children: [
    {
      path: 'new',
      breadcrumb: breadcrumbTranslation('blueprints-new'),
      lazy: () => import('pages/Blueprints/NewBlueprint'),
    },
  ],
};
